"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateBtnNoPenaltyColor = exports.generateBtnModifyColor = exports.generateBtnPassiveColor = void 0;
const constants_1 = require("utils/constants");
const generateBtnPassiveColor = (appTheme, status) => {
    if (appTheme === 'light' && status === 'Offline')
        return constants_1.color.redDark;
    if (appTheme === 'dark' && status === 'Offline')
        return constants_1.color.buttonDark;
    if (appTheme === 'light' && status === 'Online')
        return constants_1.color.redDisable;
    if (appTheme === 'dark' && status === 'Online')
        return constants_1.color.darkDisable;
    return constants_1.color.redDark;
};
exports.generateBtnPassiveColor = generateBtnPassiveColor;
const generateBtnModifyColor = (appTheme, disabled) => {
    if (appTheme === 'light' && !disabled)
        return constants_1.color.redDark;
    if (appTheme === 'dark' && !disabled)
        return constants_1.color.buttonDark;
    if (appTheme === 'light' && disabled)
        return constants_1.color.redDisable;
    if (appTheme === 'dark' && disabled)
        return constants_1.color.darkDisable;
    return constants_1.color.redDark;
};
exports.generateBtnModifyColor = generateBtnModifyColor;
const generateBtnNoPenaltyColor = (appTheme, disabled) => {
    if (appTheme === 'light' && !disabled)
        return '#4C8C8C';
    if (appTheme === 'dark' && !disabled)
        return '#4C8C8C';
    if (appTheme === 'light' && disabled)
        return '#4C8C8C';
    if (appTheme === 'dark' && disabled)
        return constants_1.color.darkDisable;
    return constants_1.color.redDark;
};
exports.generateBtnNoPenaltyColor = generateBtnNoPenaltyColor;
